// extracted by mini-css-extract-plugin
export default {"melodyVideo":"pL-z","isFullWidth":"qL-z","landingPageVideo":"rL-z","play":"sL-z","iframeVideo":"tL-z","playHidden":"uL-z","fullwidth":"vL-z"};